import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667478c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlatformNavbar = _resolveComponent("PlatformNavbar")!
  const _component_WorkspaceContainer = _resolveComponent("WorkspaceContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PlatformNavbar),
    _createVNode(_component_WorkspaceContainer, {
      ref: "workspaceContainer",
      pickedArgument: _ctx.pickedPreviewArgument
    }, null, 8, ["pickedArgument"])
  ]))
}